(function() {
  // variant_id → media_id のマップ（fetchデータ由来、不変）
  let variantToMediaId = null;

  function buildVariantSlideMap() {
    fetch(location.pathname + '.js')
      .then(r => r.json())
      .then(data => {
        const media = data.media || [];
        const variants = data.variants || [];

        // filename → media_id
        const filenameToMediaId = {};
        media.forEach(m => {
          const filename = m.src && m.src.split('?')[0].split('/').pop();
          if (filename) filenameToMediaId[filename] = m.id;
        });

        // variant_id → media_id（これだけ保持、インデックスは都度解決）
        variantToMediaId = {};
        variants.forEach(v => {
          const filename = v.featured_image && v.featured_image.src && v.featured_image.src.split('?')[0].split('/').pop();
          if (filename && filenameToMediaId[filename]) {
            variantToMediaId[v.id] = filenameToMediaId[filename];
          }
        });
      })
      .catch(() => {});
  }

  function switchGalleryImage(variantId) {
    if (!variantToMediaId) return;
    const mediaId = variantToMediaId[variantId];
    if (!mediaId) return;
    const gallery = document.querySelector('media-gallery');
    if (!gallery || !gallery.slideshow) return;

    // DOM差し替え後もズレないよう毎回インデックスを動的に解決
    const slides = gallery.querySelectorAll('[data-media-id]');
    let index = -1;
    slides.forEach((el, i) => {
      if (Number(el.dataset.mediaId) === mediaId) index = i;
    });
    if (index >= 0) gallery.slideshow.select(index);
  }

  // バリアント名（legend内 span.variant-option__swatch-value）を即時更新
  function updateVariantLabel(radio) {
    const fieldset = radio.closest('fieldset');
    if (!fieldset) return;
    const labelSpan = fieldset.querySelector('.variant-option__swatch-value');
    if (labelSpan && labelSpan.textContent !== radio.value) {
      labelSpan.textContent = radio.value;
    }
  }

  // radioのchange → 即時切り替え（Globo CLO + 画像 + バリアント名）
  document.addEventListener('change', function(e) {
    const radio = e.target.closest('variant-picker input[type="radio"]');
    if (!radio) return;

    const newId = radio.dataset.variantId;
    if (!newId) return;

    // バリアント名を即時更新
    updateVariantLabel(radio);

    // Globo CLO更新
    const input = document.querySelector('input[name="id"]');
    if (input) input.value = newId;
    const cfg = window.GPOConfigs;
    const flatElements = cfg && cfg.option && cfg.option.flatElements;
    if (flatElements && cfg.handleCLO) cfg.handleCLO(Object.values(flatElements));

    // 画像切り替え
    switchGalleryImage(newId);
  }, true);

  // variant:updateフォールバック（Globo CLO + 画像の整合性担保）
  document.addEventListener('variant:update', function(e) {
    const newId = e.detail && e.detail.resource && e.detail.resource.id;
    if (!newId) return;

    const input = document.querySelector('input[name="id"]');
    if (input && String(input.value) !== String(newId)) {
      input.value = newId;
      const cfg = window.GPOConfigs;
      const flatElements = cfg && cfg.option && cfg.option.flatElements;
      if (flatElements && cfg.handleCLO) cfg.handleCLO(Object.values(flatElements));
    }

    switchGalleryImage(String(newId));
  }, true);

  // product pageでのみ実行
  if (document.querySelector('variant-picker')) {
    buildVariantSlideMap();
  }
})();

/* [A97] variant セクションのプリフェッチ＋即返し
   バリアント切替時、サムネ配列が遅れて並び替わる（ガクッとする）問題の解消。 */
(function () {
  if (!location.pathname.startsWith('/products/')) return;

  var vp = document.querySelector('variant-picker');
  if (!vp) return;

  var radios = vp.querySelectorAll('input[type="radio"]');
  var fieldsets = {};
  radios.forEach(function (r) { fieldsets[r.getAttribute('data-fieldset-index') || '0'] = true; });
  if (Object.keys(fieldsets).length !== 1) return;

  var origFetch = window.fetch.bind(window);
  var cache = {};

  function norm(u) { try { return new URL(u, location.href).href; } catch (e) { return u; } }

  function urlForRadio(radio) {
    var ovid = radio.getAttribute('data-option-value-id');
    return ovid ? norm(location.pathname + '?option_values=' + ovid) : null;
  }

  function prefetch(url) {
    if (!url) return null;
    if (cache[url]) return cache[url];
    cache[url] = origFetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { cache[url] = t; return t; })
      .catch(function () { delete cache[url]; return null; });
    return cache[url];
  }

  // 切替の意図（hover/focus/押下）を検知して、対象バリアントを先読み
  function onIntent(e) {
    var label = e.target && e.target.closest && e.target.closest('variant-picker label');
    if (!label) return;
    var radio = label.querySelector('input[type="radio"]');
    if (radio) prefetch(urlForRadio(radio));
  }
  document.addEventListener('pointerover', onIntent, true);
  document.addEventListener('focusin', onIntent, true);
  document.addEventListener('pointerdown', onIntent, true);

  // Fabricのfetchへ即返し（先読み済みなら待たせない）
  window.fetch = function () {
    var raw = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var key = norm(raw), entry = cache[key];

    if (typeof entry === 'string') {
      return Promise.resolve(new Response(entry, { status: 200, headers: { 'Content-Type': 'text/html' } }));
    }
    if (entry && typeof entry.then === 'function') {
      var self = this, args = arguments;
      return entry.then(function (t) {
        return typeof t === 'string'
          ? new Response(t, { status: 200, headers: { 'Content-Type': 'text/html' } })
          : origFetch.apply(self, args);
      });
    }
    return origFetch.apply(this, arguments);
  };

  // ロード時グルーピング即時化（variant リンクで来た時のみ）
  function firstSlideId(html) {
    var i = html.indexOf('<slideshow-component');
    if (i < 0) return null;
    var m = html.slice(i, i + 20000).match(/data-media-id="(\d+)"/);
    return m ? m[1] : null;
  }
  function groupOnLoad() {
    if (!/[?&]variant=/.test(location.search)) return; // 通常ロード(=デフォルトvariant)は通常配列でOK
    var checked = vp.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    var url = urlForRadio(checked);
    if (!url) return;
    Promise.resolve(prefetch(url)).then(function (html) {
      if (typeof html !== 'string') return;
      var target = firstSlideId(html);
      var ss = document.querySelector('slideshow-component');
      var liveEl = ss && ss.querySelector('[data-media-id]');
      var live = liveEl ? liveEl.getAttribute('data-media-id') : null;
      // 既に variant 配列なら何もしない（不要な再レンダー回避）
      if (target && live && target !== live) {
        checked.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', groupOnLoad);
  else groupOnLoad();
})();